import { useTranslation } from 'react-i18next';

/**
 * @param {{ en?: string, ar?: string } | string | null | undefined} text
 */
export function getLocalizedText(text, locale = 'ar') {
  if (!text) return '';
  if (typeof text === 'string') return text;
  return text[locale] || text.ar || text.en || '';
}

export function useLocalizedText(text) {
  const { i18n } = useTranslation();
  return getLocalizedText(text, i18n.language);
}
